import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { SIGNIN_PATH } from '../auth.models';
import { AuthStore } from '../auth.store';

export const authGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // 認証済みなら SDK 呼び出しをスキップして高速化する。
  // 401 → UnauthorizedHandlerService.handle() → logout() で isAuthenticated が false に戻るため、
  // セッション失効時は次回ガードで checkAuthStatus が再実行される。
  // checkAuthStatus は内部で例外を store の error/未認証状態に変換するため reject されない。
  if (!authStore.isAuthenticated()) {
    await authStore.checkAuthStatus();
  }

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([SIGNIN_PATH]);
};
